import { useEffect, useState } from 'react';
import { useIfaStore } from '@ifa/store';
import { api } from '@ifa/trpc-client';

const INTERVAL_NO_TASKS = 60000;
const INTERVAL_HAS_TASKS = 10000;
const INTERVAL_NEW_REQUEST = 5000;

let intervalNewRequestTimes = 5;

function DataFetcher() {
    const setData = useIfaStore(state => state.table.setData);
    const setCurrentItem = useIfaStore(state => state.drawer.setCurrentItem);
    const setAppStatus = useIfaStore(state => state.app.setStatus);
    const shouldRefetch = useIfaStore(state => state.table.shouldRefetch);
    const shouldShortenPollTimeFromRequest = useIfaStore(state => state.table.shouldShortenPollTimeFromRequest);
    const setShouldShortenPollTimeFromRequest = useIfaStore(state => state.table.setShouldShortenPollTimeFromRequest);
    const setShouldRefetch = useIfaStore(state => state.table.setShouldRefetch);
    const [shouldShortenPollTime, setShouldShortenPollTime] = useState(false);
    const currentItem = useIfaStore(state => state.drawer.currentItem);

    const { data, error, refetch, isLoading, isFetching, isRefetching, isError, isSuccess } =
        api.submissionDetail.getAllActive.useQuery(undefined, {
            refetchInterval: () =>
                shouldShortenPollTimeFromRequest
                    ? INTERVAL_NEW_REQUEST
                    : shouldShortenPollTime
                    ? INTERVAL_HAS_TASKS
                    : INTERVAL_NO_TASKS,
        });

    useEffect(() => {
        if (data) {
            if (!shouldShortenPollTimeFromRequest) {
                const hasTasks = data.some(
                    (row: { status: string }) => row.status === 'RECEIVED' || row.status === 'PROCESSING'
                );
                setShouldShortenPollTime(hasTasks);
            }
            setData(data);
            if (currentItem !== 'Item not found' && currentItem) {
                const newCurrentItem = data.find(
                    (submissionDetail: { submissionId: number }) =>
                        submissionDetail.submissionId === currentItem.submissionId
                );
                if (newCurrentItem) {
                    setCurrentItem(newCurrentItem);
                }
            }
        }
    }, [currentItem, data, shouldShortenPollTimeFromRequest]);

    useEffect(() => {
        if (shouldRefetch) {
            refetch();
            setShouldRefetch(false);
        }
    }, [shouldRefetch, refetch, setShouldRefetch]);

    useEffect(() => {
        if (isSuccess) {
            if (shouldShortenPollTimeFromRequest && intervalNewRequestTimes <= 0) {
                setShouldShortenPollTimeFromRequest(false);
                intervalNewRequestTimes = 5;
            } else if (shouldShortenPollTimeFromRequest) {
                intervalNewRequestTimes--;
            }
            setAppStatus({ status: 'idle' });
        }

        if (isError) {
            setAppStatus({ status: 'error', error: error.message });
        }

        if (isLoading || isFetching || isRefetching) {
            setAppStatus({ status: 'fetching' });
        }
    }, [isLoading, isFetching, isRefetching, isError, isSuccess, error, setAppStatus]);
}

export default DataFetcher;
